import { create } from 'zustand';
import { projectAPI } from '../services/api';

interface Project {
  id: number;
  name: string;
  well_name: string;
  field_name: string;
  status: string;
  well_type: string;
  target_formation: string;
  total_depth: number | null;
  // 从已入库数据推导: 完钻井深取测斜最深测点, 目的层取标了 is_target 的地层。
  // 项目档案里没填时用它们, 数据没导入时两者都是 null, 界面显示 "-"。
  derived_total_depth?: number | null;
  derived_target_formation?: string | null;
  owner_name: string;
  member_count: number;
  created_at: string;
  updated_at: string;
}

interface ProjectState {
  projects: Project[];
  currentProject: Project | null;
  loading: boolean;
  fetchProjects: () => Promise<void>;
  setCurrentProject: (project: Project) => void;
  clearProject: () => void;
  validateCurrentProject: () => Promise<boolean>;
}

export const useProjectStore = create<ProjectState>((set, get) => ({
  projects: [],
  currentProject: JSON.parse(localStorage.getItem('current_project') || 'null'),
  loading: false,

  fetchProjects: async () => {
    set({ loading: true });
    try {
      const { data } = await projectAPI.list();
      set({ projects: data.results || data, loading: false });
    } catch {
      set({ loading: false });
    }
  },

  setCurrentProject: (project) => {
    localStorage.setItem('current_project', JSON.stringify(project));
    set({ currentProject: project });
  },

  clearProject: () => {
    localStorage.removeItem('current_project');
    set({ currentProject: null });
  },

  /** 校验缓存里的当前项目对**现在这个登录用户**是否还访问得到。
   *
   *  只在登录/退出时清 localStorage 是不够的: token 过期后重新登录、
   *  在另一个标签页换账号、或者项目被移出成员, 都绕得过去。这里实打实问一次后端,
   *  拿不到就清掉 —— 否则侧栏会挂着别人的井名, 且每个请求都带着一个越权的
   *  project_id, 报出来的是"项目不存在或无权访问", 看着像权限坏了。
   *
   *  返回 true 表示当前项目可用。 */
  validateCurrentProject: async () => {
    const current = get().currentProject;
    if (!current) return false;
    try {
      const { data } = await projectAPI.get(current.id);
      // 顺便把名字等信息刷新一下 (别人改过项目名时不至于显示旧的)
      localStorage.setItem('current_project', JSON.stringify(data));
      set({ currentProject: data });
      return true;
    } catch {
      localStorage.removeItem('current_project');
      set({ currentProject: null });
      return false;
    }
  },
}));
